export const SvgDefs = () => (
  <svg height="0" width="0" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="dark" x1="64" x2="64" y1="128" y2="0" gradientUnits="userSpaceOnUse">
        <stop stopColor="#42E8E0" />
        <stop offset=".1" stopColor="#3CC9CD" />
        <stop offset=".34" stopColor="#2F87A5" />
        <stop offset=".507" stopColor="#147674" />
        <stop offset=".664" stopColor="#044E62" />
        <stop offset=".812" stopColor="#033E4E" />
        <stop offset=".976" stopColor="#022731" />
      </linearGradient>
      <radialGradient
        id="light"
        cx="-0.2"
        cy="0"
        r="1.2"
        gradientTransform="rotate(-89.171 59.482 6.223) scale(65.6156 272.974)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".09" stopColor="#65E7D0" />
        <stop offset=".47" stopColor="#67DFFE" />
        <stop offset=".75" stopColor="#B8F0FE" />
        <stop offset=".89" stopColor="#CDF4FE" />
        <stop offset="1" stopColor="#EBFAFE" />
      </radialGradient>
    </defs>
  </svg>
);
